<template>
    <div>
        <v-container>
            <div class="text-h5 text-sm-h5 text-md-h4 text-lg-h4 ma-3 text-xl-h4 text-center">
                Consulta de documentos
            </div>
            <!-- <v-row justify="center">
                <v-checkbox
                    v-model="filtros.DebugPersona"
                    :label="'Debug - Filtrar por persona'"
                ></v-checkbox> 
            </v-row> -->
            <v-expansion-panels v-model="activePanels">
                <v-expansion-panel style="background-color: #F5F5F5" @click.prevent="toogleFilters">
                    <v-expansion-panel-header>
                        <span class="header">Filtros</span>
                        <template v-slot:actions>
                            <v-btn icon @click.stop="toogleFilters">
                                <v-icon>mdi-menu-down</v-icon>
                            </v-btn>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-form :disabled="loading">
                            <v-row>
                                <v-col cols="12" sm="6" md="6" lg="3" xl="3">
                                    <v-select
                                        class="mb-n5"
                                        dense outlined
                                        v-model="filtros.Tipo"
                                        :items="opcionesTipo"
                                        item-value="value"
                                        item-text="label"
                                        no-data-text="Elige un tipo"
                                        label="Tipo"
                                        clearable
                                        :menu-props="{ offsetY: true }"
                                        @change="loadData">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="4" lg="3" xl="2">
                                    <v-select
                                        class="mb-n5"
                                        dense outlined
                                        v-model="filtros.Estado"
                                        :items="opcionesEstado"
                                        item-value="value"
                                        item-text="label"
                                        no-data-text="Elige un estado"
                                        label="Estado"
                                        clearable
                                        :menu-props="{ offsetY: true }"
                                        @change="loadData">
                                    </v-select>
                                </v-col>
                                <v-col class="mb-n5" cols="12" sm="4" md="3" lg="3" xl="2">
                                    <DateFind label="Fecha desde" v-model="filtros.FechaDesde" @change="loadData"></DateFind>
                                </v-col>
                                <v-col class="mb-n5" cols="12" sm="4" md="3" lg="3" xl="2">
                                    <DateFind label="Fecha hasta" v-model="filtros.FechaHasta" @change="loadData"></DateFind>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <br>

            <v-data-table
                :headers="headers"
                :items="dataRows"
                :item-class="selectedRow"
                :options.sync="options"
                :footer-props="{itemsPerPageOptions: [15, 30, 50, 100]}"
                :server-items-length="totalDataRows"
                :loading="loading"
                @click:row="onClickRow"
                style="overflow: scroll"
                mobile-breakpoint="0"
                class="elevation-1 docs-table"
                dense>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.Datos="{ item }">
                    {{ formatDate(item.DesdeF) }} - {{formatDate(item.HastaF)}}
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.FecCrea="{ item }">
                    {{ formatDate(item.FecCrea) }}
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.FecFirma="{ item }">
                    {{ formatDate(item.FecFirma) }}
                </template>
            </v-data-table>

            <v-row justify="center">
                <v-btn
                    :to="selectedItemDocLink()"
                    :disabled="selectedItem==null"
                    :loading="selectedItem!=null && loading"
                    color="primary"
                    class="mr-2 mt-6 mb-4">
                    Ver Documento
                </v-btn>
                <v-btn
                    :disabled="selectedItem==null || selectedItem.FecFirma == null"
                    :loading="selectedItem!=null && (loading || downloading)"
                    color="primary"
                    class="mt-6 mb-4"
                    @click="onBtnDescargar">
                Descargar
                </v-btn>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import DateFind from "../components/DateFind.vue";
export default ({
    components: {
      DateFind
    },
    computed: {
        ...mapState(['empId', 'perId', 'urlRaiz'])
    },
    data () {
        return {
            loading: true,
            downloading: false,
            activePanels: 0,
            filtros: {
              Tipo: null,
              Estado: null,
              FechaDesde: null,
              FechaHasta: null,
              DebugPersona: true
            },
            opcionesTipo: [
              { label: 'Anexo de contrato', value: 3 },
              { label: 'Cambio de jornada', value: 1 },
              { label: 'Cambio de jornada definitivo', value: 0 },
              { label: 'Vacaciones', value: 2 },
              { label: 'Renuncia a reconocimiento médico', value: 5 },
            ],
            opcionesEstado: [
              { label: 'Firmadas', value: true },
              { label: 'Pendientes de firmar', value: false }
            ],
            selectedItem: null,
            totalDataRows: 0,
            dataRows: [],
            options: {itemsPerPage: 15},
            headers: [
                { text: 'Tipo', width: 200, sortable: false, value: 'Tipo' },
                { text: 'Datos', width: 200, sortable: false, value: 'Datos' },
                { text: 'Fecha creación', width:125, sortable: false, value: 'FecCrea' },
                { text: 'Fecha firma', width: 125, sortable: false, value: 'FecFirma' },
            ],
            dtOptionsLoaded: false
        }
    },
    watch: {
      options: {
        handler () {
          if(!this.dtOptionsLoaded) {
            this.dtOptionsLoaded = true;
            return;
          }
          this.loadData();
        },
        deep: true
      },
      // filtros: {
      //   handler () {
      //     this.loadData();
      //   },
      //   deep: true
      // }
    },
    mounted() {
      const actualYear = new Date().getFullYear();
      this.filtros.FechaDesde = (actualYear - 1) + '-01-01';
      this.filtros.FechaHasta = actualYear + '-12-31';

      this.loadData();
    },
    methods: {
      getDataFromApi() {
        this.loading = true;

        var NumRegsPag = this.options.itemsPerPage;
        var NumPag = this.options.page;

        return new Promise((resolve) => {
          const controllerParameters = {
            Action: 'CONSULTA_DOCS_LIST_PAGINATED',
            PerId: this.perId,
            NumRegsPag: NumRegsPag,
            NumPag: NumPag,
            Filtros: {
                Tipo: this.filtros.Tipo == null ? null : this.filtros.Tipo,
                Estado: this.filtros.Estado == null ? null : this.filtros.Estado,
                FechaDesde: this.filtros.FechaDesde == null ? null : this.filtros.FechaDesde,
                FechaHasta: this.filtros.FechaHasta == null ? null : this.filtros.FechaHasta
            },
            DebugPersona: this.filtros.DebugPersona
          };       
          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/per", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const items = result.data.EntsList;
            const total = result.data.EntsTotCount;

            setTimeout(() => {
                this.loading = false;
                resolve({
                  items,
                  total
                })
            }, 1000)
          })
          .catch(error => {
            if(error != null) {
                this.loading = false;
                alert('Error al cargar los documentos.');
            }
          });
        })
      },
      getDocFromApi() {
        this.loading = true;

        return new Promise((resolve) => {
          const controllerParameters = {
            Action: 'CONSULTA_DOC',
            CodCarta: this.selectedItem.CodCarta,
            Firmado: this.selectedItem.FecFirma != null
          };       
          const AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/per", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } })
          .then(result => {
            const item = result.data;

            setTimeout(() => {
                this.loading = false;
                resolve({
                  item
                })
            }, 1000)
          })
          .catch(error => {
            if(error != null) {
                this.loading = false;
                alert('Error al obtener el documento.');
            }
          });
        })
      },
      loadData() {
        this.selectedItem = null;
        this.getDataFromApi()
        .then(data => {
          this.dataRows = data.items;
          this.totalDataRows = data.total;
        });
      },
      descargarDocumento(doc, docName) {
        this.downloading = true;

        // Datos del fichero
        const firmado = this.selectedItem.FecFirma != null;
        const contentType = this.selectedItem.codCarta + (firmado ? 'application/pdf' : 'image/jpg');
        
        // Covertir de base 64 a Blob
        const byteCharacters = atob(doc);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {type: contentType});

        // Descarga del fichero
        const url = window.URL.createObjectURL(blob);
        var a = document.createElement('a'); 
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = docName; // Nombre del fichero
        a.click();
        a.remove();

        this.downloading = false;
      },
      onClickRow(item) {
        this.selectedItem = item;
      },
      onBtnDescargar() {
        this.getDocFromApi()
        .then(data => {
          if(data.item === '') { 
            alert('Documento no encontrado.');
            return; 
          }
          this.descargarDocumento(data.item.File, data.item.FileName);
        });
      },
      toogleFilters() {
        this.activePanels = this.activePanels == null ? 0 : undefined;
      },
      selectedItemDocLink() {
        if(this.selectedItem == null) { return '/'; }

        const baseUrl = '/documentos-consulta/';
        const firmado = this.selectedItem.FecFirma != null ? '1/' : '0/'
        
        return baseUrl + firmado + this.selectedItem.CodCarta.trim();
      },
      selectedRow(item) {
          if(this.selectedItem == null) { return ''; }
          if(item.CodCarta === this.selectedItem.CodCarta) {
              return 'selected-row';
          }
          return '';
      },
      formatDate (value) {
        if(value == null) { return ''; }
        const date = new Date(value);
        return String(date.getDate()).padStart(2, '0') + '/' + 
            String(date.getMonth() + 1).padStart(2, '0')  + '/' + 
            date.getFullYear();
      }
    } 
})
</script>

<style>
  /* .docs-table > .v-data-table__wrapper > table {
      border-collapse: collapse;
  } */
  .docs-table .selected-row {
      /* border: 4px solid #FF4848; */
      background-color: #AECAFF;
  }
  .docs-table .selected-row:hover {
      background-color: #A3C3FF !important;
  }
</style>
